import React from "react";
import MainRoute from "./router";
import PageInfo from "./components/PageInfo";
import {BrowserRouter as Router} from "react-router-dom";

export default class AppRoot extends React.Component {

	state = {};

	render()
	{
		return (
				<Router forceRefresh={true}>
					<React.Fragment>
						<MainRoute/>
						<PageInfo/>
					</React.Fragment>
				</Router>
		)
	}
}
